const state = {
  addTodo: false,
  newTodo: {},
  delTodo: false,
  backTodo: {},
}
export default state;
